import React, { useContext, useMemo } from 'react'
import { StoresContext } from '@App/contexts'
import { FormFieldType } from '@App/forms/v2/common/form-field'
import { addressFormKey, AddressType } from '@Entities/schemas/common/address-schema'
import MailingAddress from '@Fields/v2/MailingAddress'
import MemberAddressToolTip from '@Scenes/RightsholderRegistrationLayout/RightsholderRegistrationForm/MemberAddressToolTip'
import Checkbox from '@Components/Selectors/Checkbox'
import { useFormContext } from 'react-hook-form'
import { observer } from 'mobx-react'

interface RightsholderAddressProps {
    address: FormFieldType<AddressType>
}

const useUserDetailsId = 'useUserDetailsId'

const RightsholderAddress = ({ address }: RightsholderAddressProps) => {
    const { userStore } = useContext(StoresContext)
    const { watch, setValue } = useFormContext()

    const memberTypeValue = watch('memberType')

    const disableUseExistingCheckbox = useMemo(
        () => memberTypeValue === 'CMO' || memberTypeValue === 'Publisher' || memberTypeValue === 'Administrator',
        [memberTypeValue]
    )

    const useUserDetails = (checkboxState: boolean, id: string) => {
        if (checkboxState && useUserDetailsId === id) {
            const { email, streetAddress, city, state, countryId, postalCode } = userStore.userInfo
            setValue('email', email)
            setValue(addressFormKey, {
                streetAddress: streetAddress,
                city: city,
                state: state || '',
                countryId: countryId ? String(countryId) : '',
                postalCode: postalCode || '',
            })
        }
    }

    return (
        <MailingAddress
            addressFormFields={address}
            title="Member Address"
            toolTip={<MemberAddressToolTip />}
            subSection={
                <Checkbox
                    disabled={disableUseExistingCheckbox}
                    mainColor
                    id={useUserDetailsId}
                    onClick={useUserDetails}
                    text="Use my existing user account details"
                />
            }
        />
    )
}

export default observer(RightsholderAddress)
